import { Component, OnInit} from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import {FormBuilder, FormGroup} from '@angular/forms';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-resultados',
  templateUrl: './resultados.component.html',
  styleUrls: ['./resultados.component.scss'],
  animations : fuseAnimations
})
export class ResultadosComponent implements OnInit {

  constructor(fb: FormBuilder,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

  }

  ngOnInit() {
  }


}
